export const paths = {
  index: "/",
  home: "/home",
  aboutUs: "/about-us",
  contactUs: "/contact-us",
  vision: "/vision",
  ourBrands: "/our-brands",
  termsAndConditions: "/terms-and-conditions",
  brands: {
    renee: "/renee",
    juvelook: "/juvelook",
    lenisna: "/lenisna",
    ksurgery: "/ksurgery",
    dimono: "/dimono",
    ellanse:"/ellanse",
    lanluma:"/lanluma",
    maili:"/maili",
    drcyj:"/DR-CYJ"
  },
};
